<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import authService from './common/auth.js'

export default {
  name: 'App',
  async mounted() {
    // 设置登录进行中的标记
    try {
      sessionStorage.setItem('logging_in', '1');
    } catch (e) {
      // 忽略 sessionStorage 不可用等异常
    }
    
    // 应用挂载完成后立即执行自动登录（取消延时）
    const result = await authService.autoLogin();
    if (result.success) {
      this.$store.commit('setToken', result.token);
      // 触发token设置完成事件
      this.$emit('token-ready');
      // 同时触发全局事件
      this.$root.$emit('token-ready');
    }
    
    // 登录完成（无论成功或失败），清除登录进行中的标记
    try {
      sessionStorage.removeItem('logging_in');
    } catch (e) {
      // 忽略 sessionStorage 不可用等异常
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
}
</style> 